export default __webpack_public_path__ + "static/media/contacts-icon-bubble.72dec3be.svg";